import * as React from 'react';
import { inject } from 'mobx-react';
import { ErrorBoundary } from 'bernie-view';
import { EGDSLayoutGrid, EGDSLayoutGridItem } from '@egds/react-core/layout-grid';
import { EGDSSpacing } from '@egds/react-core/spacing';
import { useExperiment } from '@shared-ui/experiment-context';
import { GridViewToggle } from 'components/search/results-sub-header/grid-view-toggle';
import { SplitViewResultsSubHeaderWrapper } from './results-sub-header/split-view-results-sub-header-wrapper';
import { ShoppingSearchListingHeaderWrapper } from './shopping-search-listing-header-wrapper';
export const SplitViewResultsHeader = inject('searchResults')(({
  searchResults
}) => {
  const {
    exposure: gridViewExperimentExposure
  } = useExperiment('SRP_Grid_view_web', false);
  // don't render header at all if there are no search results
  if (!searchResults) {
    return null;
  }
  const {
    isLoading
  } = searchResults;
  const isError = searchResults === null || searchResults === void 0 ? void 0 : searchResults.isError;
  const hasValidShoppingSearchListingHeader = searchResults === null || searchResults === void 0 ? void 0 : searchResults.hasValidShoppingSearchListingHeader();
  // at some future point we might render a loading message, but until then, the component should return null while loading
  if (isLoading || isError) {
    return null;
  }
  return React.createElement(ErrorBoundary, {
    label: "hotel.search.tools"
  }, React.createElement("section", {
    "data-stid": "split-view-results-header"
  }, React.createElement("header", null, React.createElement(EGDSLayoutGrid, {
    columns: (gridViewExperimentExposure === null || gridViewExperimentExposure === void 0 ? void 0 : gridViewExperimentExposure.bucket) ? 2 : 1
  }, React.createElement(EGDSLayoutGridItem, null, React.createElement(React.Fragment, null, Boolean(hasValidShoppingSearchListingHeader) && React.createElement(ShoppingSearchListingHeaderWrapper, null), React.createElement(EGDSSpacing, {
    margin: {
      blockstart: hasValidShoppingSearchListingHeader ? 'three' : undefined
    }
  }, React.createElement("div", null, React.createElement(SplitViewResultsSubHeaderWrapper, null))))), React.createElement(EGDSLayoutGridItem, {
    alignSelf: 'end'
  }, React.createElement(GridViewToggle, null))))));
});